export default __webpack_public_path__ + "static/media/logo-b.8d7af56d.svg";